import { ExternalLink } from "lucide-react";

const hotels = [
  {
    name: "Cabarete Palm Beach Condos",
    distance: "2 min walk",
    notes: "Beachfront condos in the heart of Cabarete, steps to the action.",
    img: "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1200&q=85",
    link: "https://www.booking.com/hotel/do/palm-beach-condos.html",
  },
  {
    name: "Tropical Casa Laguna",
    distance: "3 min walk",
    notes: "Outdoor pool, garden, on-site bar — chill and well-priced.",
    img: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&w=1200&q=85",
    link: "https://www.booking.com/hotel/do/tropical-casa-laguna.html",
  },
  {
    name: "Casa MIA",
    distance: "3 min walk",
    notes: "Tucked just off the beach, simple and quiet, easy walk to everything.",
    img: "https://images.unsplash.com/photo-1540541338287-41700207dee6?auto=format&fit=crop&w=1200&q=85",
    link: "https://www.booking.com/hotel/do/casa-mia-cabarete.html",
  },
  {
    name: "Le Reef Beach Condos",
    distance: "3 min walk",
    notes: "Oceanfront condos with king beds, full kitchens, and the Front Loop restaurant on-site.",
    img: "https://frontloopcabarete.com/wp-content/uploads/2024/08/DSC02012-HDR.jpg",
    link: "https://frontloopcabarete.com/le-reef-condo-rentals/",
  },
  {
    name: "Cabarete Ocean View",
    distance: "3 min walk",
    notes: "Two-bedroom unit, prime location, great for couples or small groups sharing.",
    img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&w=1200&q=85",
    link: "https://www.booking.com/hotel/do/cabarete-ocean-view-2-bedrooms-prime-location.html",
  },
  {
    name: "Airbnb rentals",
    distance: "Cabarete area",
    notes: "Great for bigger groups, your own kitchen, or your own pool.",
    img: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=85",
    link: "https://www.airbnb.com/s/Cabarete--Dominican-Republic/homes",
  },
];

export default function OtherHotels() {
  return (
    <div className="bg-cream">
      <section className="pt-20 pb-10 md:pt-28 md:pb-14" data-testid="hotels-hero">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-terracotta font-medium mb-4">If Villa Taina is full</p>
          <h1 className="font-display text-6xl md:text-8xl font-black text-ink leading-[0.9]">
            Other <span className="italic text-sage-dark">hotels.</span>
          </h1>
          <p className="text-lg text-muted_ink mt-5 max-w-2xl">
            Couldn't grab a Villa Taina room? Want your own pool? Here's a short list I've vetted.
            (These are placeholders while I finalize my picks. Distance shown is ballpark.)
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {hotels.map((h, i) => (
            <a
              key={h.name}
              href={h.link}
              target="_blank"
              rel="noreferrer"
              className="group block bg-sand border border-shell rounded-lg overflow-hidden hover:-translate-y-1 transition-transform duration-300"
              data-testid={`hotel-${i}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={h.img} alt={h.name} className="w-full h-full object-cover vintage-filter group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-5">
                <div className="flex items-baseline justify-between gap-3">
                  <h3 className="font-display text-2xl font-black text-ink leading-tight">{h.name}</h3>
                  <ExternalLink className="w-4 h-4 text-muted_ink group-hover:text-terracotta transition-colors flex-shrink-0" />
                </div>
                <p className="text-sm text-muted_ink mt-2">{h.notes}</p>
                <div className="flex items-center mt-4 pt-4 border-t border-shell text-sm">
                  <span className="text-sage-dark font-medium">{h.distance}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}
